import { Region } from '@moonpig/web-core-types'
import { type AllFlagIDs } from '@moonpig/web-explore-flags'
import { getCardVariantIdsEnabled } from '@moonpig/web-shared-products'
import { SearchFeatures } from '../types/searchFeatures'

type Experiments = {
  [key: string]: string | undefined
}

export type LoadFeaturesProps = {
  region: Region
  experiments: Experiments
  flags: Partial<Record<AllFlagIDs, boolean>>
}

const getExperiment = (experiments: Experiments, key: string) => {
  if (
    experiments[key]?.toLowerCase() === 'enabled' ||
    experiments[key]?.toLowerCase() === 'variant'
  ) {
    return `${key}=true`
  }
  if (experiments[key]?.toLowerCase() === 'original') {
    return `${key}=false`
  }
  return ''
}

export const loadFeatures: (props: LoadFeaturesProps) => SearchFeatures = ({
  flags,
  experiments,
}) => {
  const isFlagOn = (key: string) => flags[key as keyof typeof flags] ?? false

  const showCollageMaker = isFlagOn('search-show-collage-maker')

  const cardVariants = getCardVariantIdsEnabled()

  const experimentValues = [
    'search-use-new-ia-index=true',
    getExperiment(experiments, 'search-use-smart-department-redirection'),
    getExperiment(experiments, 'search-use-age-selection-ux'),
  ]
    .filter(Boolean)
    .join('&')

  return {
    searchUseNewIaIndex: true,
    showCollageMaker,
    cardVariants,
    experimentValues,
    nbaAlgorithm: 'NBA_5',
  }
}
